import React, {FC} from 'react';

import avatar from 'assets/images/svg/avatar.svg';

import {ReferralUser as ReferralUserModel} from '../../../../api-client';
import {formatDate} from '../../../../formatters';
import {Money} from '../../../common';
import styles from './ReferralUser.module.scss';

interface Props {
  user: ReferralUserModel;
}

const ReferralUser: FC<Props> = ({user}) => {
  return (
    <li className={styles.referralUser}>
      <div className={styles.header}>
        <div className={styles.userInfo}>
          <img src={avatar} alt="аватар" className={styles.avatar} />
          <div>
            <div className={styles.name}>{user.name || '—'}</div>
            <div className={styles.phone}>{user.phone}</div>
          </div>
        </div>
        {user.totalUserAccrued && (
          <div className={styles.totalAccruals}>
            <div className={styles.amount}>
              {user.totalUserAccrued ? <Money money={user.totalUserAccrued} /> : 'Сумма начислений'}
            </div>
            <div className={styles.label}>Всего начислено</div>
          </div>
        )}
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.meta}>
          <div>
            <div className={styles.label}>Дата регистрации</div>
            <div className={styles.value}>
              {user.registerDate ? formatDate(user.registerDate) : '—'}
            </div>
          </div>
          <div>
            <div className={styles.label}>Ставка дохода</div>
            <div className={styles.value}>{user.totalUserAccrued ? '1% бессрочно' : '—'}</div>
          </div>
        </div>

        {user.transactions && user.transactions.length > 0 ? (
          <div className={styles.infoGrid}>
            <div className={styles.gridHeader}>
              <span>Инвестиция</span>
              <span>Дата</span>
              <span>Начисление</span>
            </div>
            {user.transactions.map((tra) => {
              const date = formatDate(tra.date);

              return (
                <div className={styles.gridRow} key={tra.uuid}>
                  <span className={styles.moneyWrapper}>
                    {tra.investedMoney && tra.investedMoney.amount > 0 ? (
                      <Money money={tra.investedMoney} />
                    ) : (
                      '—'
                    )}
                  </span>
                  <span>{date}</span>
                  <span>
                    <Money money={tra.money} />
                  </span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.infoGrid}>
            <div className={styles.gridHeader}>
              <span>Инвестиция</span>
              <span>Дата</span>
              <span>Начисление</span>
            </div>
            <div className={styles.gridRow}>
              <span className={styles.blank}>{'—'}</span>
              <span className={styles.blank}>{'—'}</span>
              <span className={styles.blank}>{'—'}</span>
            </div>
          </div>
        )}
      </div>
    </li>
  );
};

export default ReferralUser;
